var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "move-out-section",
        {
          ref: "moveOutContracts",
          attrs: {
            number: "1",
            title: "Muuttoilmoituksen tiedot",
            mode: _vm.sections.moveOutContracts.mode,
            "trusted-customer": _vm.trustedCustomer,
            "proceed-action-state": _vm.sections.moveOutContracts.proceedActionState()
          },
          on: {
            modify: function($event) {
              return _vm.sections.moveOutContracts.enterModify()
            },
            proceed: function($event) {
              return _vm.sections.moveOutContracts.proceed()
            }
          }
        },
        [
          _c("move-out-contracts-selection", {
            ref: "moveOutContractsSelection",
            attrs: {
              slot: "edit",
              contract: _vm.contract,
              "trusted-customer": _vm.trustedCustomer,
              "validation-errors": _vm.validationErrors
            },
            on: { notifyValidationError: _vm.notifyValidationError },
            slot: "edit"
          }),
          _vm._v(" "),
          _c("move-out-contracts-selection-display", {
            attrs: { slot: "display", contract: _vm.contract },
            slot: "display"
          })
        ],
        1
      ),
      _vm._v(" "),
      (_vm.contract.Customer && _vm.contract.Customer.TrustedSource) ||
      _vm.trustedCustomer
        ? _c(
            "move-out-section",
            {
              ref: "moveOutCustomer",
              attrs: {
                number: "2",
                title: "Asiakastiedot ja loppulaskun osoite",
                mode: _vm.sections.moveOutCustomer.mode,
                "proceed-action-state": _vm.sections.moveOutCustomer.proceedActionState()
              },
              on: {
                proceed: function($event) {
                  return _vm.sections.moveOutCustomer.proceed()
                },
                modify: function($event) {
                  return _vm.sections.moveOutCustomer.enterModify()
                }
              }
            },
            [
              _vm.contract.CustomerType == _vm.CustomerTypeEnum.CONSUMER
                ? _c("move-out-customer-selection", {
                    ref: "moveOutCustomerSelection",
                    attrs: {
                      slot: "edit",
                      contract: _vm.contract,
                      "validation-errors": _vm.validationErrors
                    },
                    slot: "edit"
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.contract.CustomerType == _vm.CustomerTypeEnum.CONSUMER
                ? _c("move-out-customer-selection-display", {
                    attrs: { slot: "display", contract: _vm.contract },
                    slot: "display"
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.contract.CustomerType === _vm.CustomerTypeEnum.COMPANY &&
      (_vm.contract.Customer.TrustedSource || _vm.trustedCustomer)
        ? _c(
            "move-out-section",
            {
              ref: "moveOutCustomer",
              attrs: {
                number: "2",
                title: "Asiakastiedot ja loppulaskun osoite",
                mode: _vm.sections.moveOutCustomer.mode,
                "proceed-action-state": _vm.sections.moveOutCustomer.proceedActionState(),
                "show-next-step": _vm.newContractMode
              },
              on: {
                proceed: function($event) {
                  return _vm.sections.moveOutCustomer.proceed()
                },
                modify: function($event) {
                  return _vm.sections.moveOutCustomer.enterModify()
                }
              }
            },
            [
              _vm.contract.CustomerType == _vm.CustomerTypeEnum.COMPANY
                ? _c("move-out-company-selection", {
                    ref: "moveOutCompanySelection",
                    attrs: {
                      slot: "edit",
                      contract: _vm.contract,
                      "validation-errors": _vm.validationErrors
                    },
                    slot: "edit"
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.contract.CustomerType == _vm.CustomerTypeEnum.COMPANY
                ? _c("move-out-company-selection-display", {
                    attrs: { slot: "display", contract: _vm.contract },
                    slot: "display"
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "move-out-section",
        {
          ref: "processSelector",
          attrs: {
            number: "3",
            title: "Sopimus uuteen kohteeseen",
            mode: _vm.sections.processSelector.mode,
            "proceed-action-state": _vm.sections.processSelector.proceedActionState()
          },
          on: {
            modify: function($event) {
              return _vm.sections.processSelector.enterModify()
            },
            proceed: function($event) {
              return _vm.sections.processSelector.proceed()
            }
          }
        },
        [
          _c("move-out-process-selector", {
            ref: "processSelectorSelection",
            attrs: { slot: "edit" },
            on: {
              "process-selected": function($event) {
                return _vm.processSelected()
              }
            },
            slot: "edit"
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.newContractMode()
        ? _c(
            "move-out-section",
            {
              ref: "preProduct",
              attrs: {
                number: "4",
                title: "Uuden kohteen tiedot",
                mode: _vm.sections.preProduct.mode,
                "proceed-action-state": _vm.sections.preProduct.proceedActionState()
              },
              on: {
                modify: function($event) {
                  return _vm.sections.preProduct.enterModify()
                },
                proceed: function($event) {
                  return _vm.sections.preProduct.proceed()
                }
              }
            },
            [
              _c("pre-product-selection", {
                ref: "preProductSelection",
                attrs: {
                  slot: "edit",
                  contract: _vm.contract,
                  "validation-errors": _vm.validationErrors
                },
                slot: "edit"
              }),
              _vm._v(" "),
              _c("pre-product-selection-display", {
                attrs: { slot: "display", contract: _vm.contract },
                slot: "display"
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.newContractMode()
        ? _c(
            "move-out-section",
            {
              ref: "product",
              attrs: {
                number: "5",
                title: "Sopimusvalikoima",
                mode: _vm.sections.product.mode,
                "proceed-action-state": _vm.sections.product.proceedActionState()
              },
              on: {
                proceed: function($event) {
                  return _vm.sections.product.proceed()
                },
                modify: function($event) {
                  return _vm.sections.product.enterModify()
                }
              }
            },
            [
              _c("product-selection", {
                attrs: { slot: "edit" },
                on: {
                  "product-selected": function($event) {
                    return _vm.sections.product.proceed()
                  }
                },
                slot: "edit"
              }),
              _vm._v(" "),
              _c("product-selection-display", {
                attrs: { slot: "display" },
                slot: "display"
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.newContractMode() &&
      _vm.contract.CustomerType !== _vm.CustomerTypeEnum.COMPANY
        ? _c(
            "move-out-section",
            {
              ref: "customer",
              attrs: {
                number: "6",
                title: "Asiakkaan tiedot",
                mode: _vm.sections.customer.mode,
                "proceed-action-state": _vm.sections.customer.proceedActionState()
              },
              on: {
                modify: function($event) {
                  return _vm.sections.customer.enterModify()
                },
                proceed: function($event) {
                  return _vm.sections.customer.proceed()
                }
              }
            },
            [
              _vm.contract.CustomerType == _vm.CustomerTypeEnum.CONSUMER
                ? _c("customer-information", {
                    ref: "customerInformation",
                    attrs: {
                      slot: "edit",
                      validationErrors: _vm.validationErrors
                    },
                    on: { "customer-value-updated": _vm.customerValueUpdated },
                    slot: "edit"
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.contract.CustomerType == _vm.CustomerTypeEnum.CONSUMER
                ? _c("customer-information-display", {
                    attrs: { slot: "display" },
                    slot: "display"
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.newContractMode() &&
      _vm.contract.CustomerType == _vm.CustomerTypeEnum.COMPANY
        ? _c(
            "move-out-section",
            {
              ref: "company",
              attrs: {
                number: "7",
                title: "Asiakkaan tiedot",
                mode: _vm.sections.company.mode,
                "proceed-action-state": _vm.sections.company.proceedActionState()
              },
              on: {
                modify: function($event) {
                  return _vm.sections.company.enterModify()
                },
                proceed: function($event) {
                  return _vm.sections.company.proceed()
                }
              }
            },
            [
              _vm.contract.CustomerType == _vm.CustomerTypeEnum.COMPANY
                ? _c("company-information", {
                    attrs: {
                      slot: "edit",
                      validationErrors: _vm.validationErrors
                    },
                    on: { "company-value-updated": _vm.companyValueUpdated },
                    slot: "edit"
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.contract.CustomerType == _vm.CustomerTypeEnum.COMPANY
                ? _c("company-information-display", {
                    attrs: { slot: "display" },
                    slot: "display"
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.newContractMode()
        ? _c(
            "move-out-section",
            {
              ref: "moveOutMeteringPoint",
              attrs: {
                number: "8",
                title: "Osoitetiedot",
                mode: _vm.sections.moveOutMeteringPoint.mode,
                "proceed-action-state": _vm.ActionState.Hidden
              },
              on: {
                modify: function($event) {
                  return _vm.sections.moveOutMeteringPoint.enterModify()
                }
              }
            },
            [
              _c("move-out-metering-point-information", {
                ref: "moveOutMeteringPointInfo",
                attrs: {
                  slot: "edit",
                  contract: _vm.contract,
                  validationErrors: _vm.validationErrors,
                  "has-membership": _vm.hasMembership()
                },
                on: { notifyValidationError: _vm.notifyValidationError },
                slot: "edit"
              }),
              _vm._v(" "),
              _c("move-out-metering-point-information-display", {
                attrs: { slot: "display" },
                slot: "display"
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showNextPhaseButton() &&
      ((this.contract.Customer && this.contract.Customer.TrustedSource) ||
        (this.contract.Company && this.contract.Company.TrustedSource))
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12 text-center" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { type: "button", variant: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.nextPhase()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("Jatka yhteenvetoon")))]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }